import Route from 'cio/routes/base';

export default class WorkflowRoute extends Route {
  redirect(model) {
    let inactive = model.isDraft;
    let parent = inactive ? 'setup' : 'overview';

    this.router.transitionTo(`broadcasts.broadcast.${parent}.workflow`);
  }
}
